;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { svgElementAttributes } from 'svg-element-attributes';

const tags = Object.keys(svgElementAttributes);

const allowList = tags.reduce((acc, tag) => {
    acc[tag] = svgElementAttributes[tag];
    return acc;
}, {});

export default allowList;
